import { render } from "./AboutUser.vue?vue&type=template&id=2f8df42f&ts=true"
import script from "./AboutUser.vue?vue&type=script&lang=ts"
export * from "./AboutUser.vue?vue&type=script&lang=ts"

import "./AboutUser.vue?vue&type=style&index=0&id=2f8df42f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__